import { FC } from "react";
import Stack from "@mui/material/Stack";
import { BudgetDetailsAccumulatedCostChip } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/accumulated-cost-section/BudgetDetailsAccumulatedCostChip";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsAccumulatedCostDataSelector } from "@/store/budgets/selectors/details-drawer/accumulated-cost/budgetDetailsAccumulatedCostDataSelector";
import { budgetDetailsAccumulatedCostBudgetSelector } from "@/store/budgets/selectors/details-drawer/accumulated-cost/budgetDetailsAccumulatedCostBudgetSelector";

export const BudgetDetailsAccumulatedCostChipsGroup: FC = () => {
  const { used, forecast } =
    useAppSelector(budgetDetailsAccumulatedCostDataSelector) ?? {};
  const budget = useAppSelector(budgetDetailsAccumulatedCostBudgetSelector);

  return (
    <Stack direction="row">
      <BudgetDetailsAccumulatedCostChip cost={budget} title="Budget" />
      <BudgetDetailsAccumulatedCostChip cost={used} title="Used" />
      {forecast !== undefined && forecast !== null && (
        <BudgetDetailsAccumulatedCostChip cost={forecast} title="Forecast" />
      )}
    </Stack>
  );
};
